export default function ValueProposition() {
  const values = [
    {
      title: 'Operational Intelligence',
      description: 'AI systems that structure intake, follow-ups, scheduling, and client communications. Reduce manual work and ensure nothing falls through the cracks with intelligent automation designed for your specific workflows.',
      image: 'https://public.readdy.ai/ai/img_res/81a229ff6d42a905cc9600d4461a1534.jpg'
    },
    {
      title: 'Revenue Optimization',
      description: 'Automated conversion workflows that reduce lost leads and increase high-value bookings. Turn more prospects into clients with AI-powered nurturing, qualification, and scheduling systems that work 24/7.',
      image: 'https://readdy.ai/api/search-image?query=clean%20abstract%20representation%20of%20revenue%20growth%20and%20conversion%20optimization%20with%20ascending%20geometric%20shapes%20and%20data%20visualization%20elements%20in%20soft%20blue%20tones%20on%20white%20background%20minimal%20modern%20enterprise%20style%20showing%20business%20performance%20metrics&width=600&height=600&seq=vp2&orientation=squarish'
    },
    {
      title: 'Systemized Growth',
      description: 'Dashboards and automation infrastructure designed for long-term scalability. Build a foundation that grows with your business, providing clear metrics and operational control at every stage.',
      image: 'https://readdy.ai/api/search-image?query=abstract%20minimal%20dashboard%20interface%20with%20clean%20data%20visualization%20charts%20and%20scalable%20infrastructure%20elements%20in%20soft%20blue%20and%20gray%20tones%20on%20white%20background%20modern%20enterprise%20aesthetic%20showing%20systematic%20growth%20and%20operational%20clarity&width=600&height=600&seq=vp3&orientation=squarish'
    }
  ];

  return (
    <section id="solutions" className="py-32 bg-white dark:bg-[#0e1b2c] transition-colors duration-300">
      <div className="max-w-[1280px] mx-auto px-8">
        <h2 className="text-[64px] font-extralight text-center tracking-[-0.015em] text-[#0E1A2B] dark:text-[#e8edf4] mb-32">
          AI That Works Inside Real Operations
        </h2>

        <div className="space-y-40">
          {values.map((value, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-20 ${idx % 2 === 1 ? 'flex-row-reverse' : ''}`}
            >
              <div className="w-1/2">
                <div className="w-full h-[480px] rounded-2xl overflow-hidden bg-[#FAFAFA] dark:bg-[#0a1520]">
                  <img 
                    src={value.image} 
                    alt={value.title}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>

              <div className="w-1/2">
                <h3 className="text-[48px] font-light tracking-[-0.015em] text-[#0E1A2B] dark:text-[#e8edf4] mb-6">
                  {value.title}
                </h3>
                <p className="text-[21px] font-light leading-[1.5] tracking-[-0.01em] text-[#5C6675] dark:text-[#8899aa]">
                  {value.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}